import { ArrowBack } from '@mui/icons-material';
import { AlertTitle, Stack } from '@mui/material';
import type { FallbackProps } from 'react-error-boundary';
import { AlertBanner } from '../../../../primitives/alert/alert-banner';
import { Button } from '../../../../primitives/button';
import { AuthLayout } from '../../../auth-layout/auth-layout';
import { getInviteErrorContent, toInviteErrorMessage } from '../invite-error-content';
import type { InviteLogo } from '../invited-page.types';

export type InviteErrorFallbackProps = FallbackProps & { logo: InviteLogo };

/** Error-boundary fallback for an unusable invite link — expired, already accepted, suspended. */
export const InviteErrorFallback = ({ error, logo: Logo }: InviteErrorFallbackProps) => {
  const { title, description } = getInviteErrorContent(toInviteErrorMessage(error));

  return (
    <AuthLayout
      main={
        <Stack direction="column" spacing={2} sx={{ alignItems: 'center' }}>
          <Logo style={{ width: 150, display: 'block' }} height={100} />

          <AlertBanner severity="info">
            <AlertTitle>{title}</AlertTitle>
            {description}
          </AlertBanner>

          <Button
            to="/login"
            size="large"
            startIcon={<ArrowBack />}
            sx={{ textAlign: 'center', mt: 2, fontWeight: 600 }}
          >
            Back to Sign In
          </Button>
        </Stack>
      }
    />
  );
};
